import { dotS, dotS2, dotS3, dotS4 } from "./dots.js";
export const magS = (a, num, ia, sa) => Math.sqrt(dotS(a, a, num, ia, ia, sa, sa));
export const magS2 = (a, ia, sa) => Math.sqrt(dotS2(a, a, ia, ia, sa, sa));
export const magS3 = (a, ia, sa) => Math.sqrt(dotS3(a, a, ia, ia, sa, sa));
export const magS4 = (a, ia, sa) => Math.sqrt(dotS4(a, a, ia, ia, sa, sa));
